import { render, staticRenderFns } from "./CertificadoEmisionPantalla.vue?vue&type=template&id=25fb2170&scoped=true&"
import script from "./CertificadoEmisionPantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadoEmisionPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CertificadoEmisionPantalla.vue?vue&type=style&index=0&id=25fb2170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb2170",
  null
  
)

export default component.exports